import React, { useState } from 'react';
import { User, Shield, Bell, LogOut, ChevronRight } from 'lucide-react';
import { Avatar } from '../../components/ui/Avatar';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
export function StudentProfile() {
  const [isAnonymous, setIsAnonymous] = useState(false);
  return <div className="space-y-6 pb-24 md:pb-0" data-id="element-482">
      <header className="text-center py-6" data-id="element-483">
        <div className="relative inline-block mb-4" data-id="element-484">
          <Avatar src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Carlos Silva" size="xl" className="border-4 border-white shadow-md" data-id="element-485" />
          <div className="absolute bottom-0 right-0 bg-[var(--primary)] text-white p-1.5 rounded-full border-2 border-white" data-id="element-486">
            <User size={16} data-id="element-487" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-[var(--secondary)]" data-id="element-488">
          Carlos Silva
        </h1>
        <p className="text-gray-500" data-id="element-489">Membro desde Jan/2023</p>
      </header>

      <Card data-id="element-490">
        <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-491">
          <Shield size={20} className="text-[var(--primary)]" data-id="element-492" />
          Privacidade
        </h3>

        <div className="space-y-4" data-id="element-493">
          <div className="flex items-center justify-between py-2" data-id="element-494">
            <div data-id="element-495">
              <p className="font-medium text-gray-900" data-id="element-496">Modo Anônimo</p>
              <p className="text-xs text-gray-500" data-id="element-497">
                Ocultar meu nome e foto no Hall da Fama
              </p>
            </div>
            <button onClick={() => setIsAnonymous(!isAnonymous)} className={`w-12 h-6 rounded-full transition-colors relative ${isAnonymous ? 'bg-[var(--primary)]' : 'bg-gray-200'}`} data-id="element-498">
              <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${isAnonymous ? 'translate-x-6' : ''}`} data-id="element-499" />
            </button>
          </div>

          <div className="flex items-center justify-between py-2 border-t border-gray-100" data-id="element-500">
            <div data-id="element-501">
              <p className="font-medium text-gray-900" data-id="element-502">Perfil Público</p>
              <p className="text-xs text-gray-500" data-id="element-503">
                Permitir que outros alunos vejam meu perfil
              </p>
            </div>
            <button className="w-12 h-6 rounded-full bg-gray-200 relative" data-id="element-504">
              <div className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full" data-id="element-505" />
            </button>
          </div>
        </div>
      </Card>

      <div className="space-y-2" data-id="element-506">
        <button className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 shadow-sm" data-id="element-507">
          <div className="flex items-center gap-3" data-id="element-508">
            <Bell size={20} className="text-gray-400" data-id="element-509" />
            <span className="font-medium text-gray-700" data-id="element-510">Notificações</span>
          </div>
          <ChevronRight size={20} className="text-gray-300" data-id="element-511" />
        </button>

        <button className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 shadow-sm" data-id="element-512">
          <div className="flex items-center gap-3" data-id="element-513">
            <User size={20} className="text-gray-400" data-id="element-514" />
            <span className="font-medium text-gray-700" data-id="element-515">Dados Pessoais</span>
          </div>
          <ChevronRight size={20} className="text-gray-300" data-id="element-516" />
        </button>
      </div>

      <div className="pt-4" data-id="element-517">
        <Button variant="ghost" className="w-full text-red-500 hover:text-red-600 hover:bg-red-50" data-id="element-518">
          <LogOut size={20} className="mr-2" data-id="element-519" />
          Sair da Conta
        </Button>
      </div>
    </div>;
}